import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { RouteComponentProps } from 'react-router';
import { AppActions } from 'app/actions';
import { UserState } from 'app/reducers';
import { RootState } from 'app/reducers';
import { omit } from 'app/utils';
import { ClassFinder } from 'app/components/ClassFinder';
import { Subscription } from 'app/components/Subscription';
import { Spinner, Intent, Callout, Button, Classes, Divider, Card, Popover, Navbar, NavbarDivider, NavbarGroup, NavbarHeading, Toaster, Position, MenuItem } from '@blueprintjs/core';
import { Select } from '@blueprintjs/select';
import { ClassOverview } from 'app/components/ClassOverview';
import * as superagent from 'superagent';

import { SingleOverview } from 'app/components/SingleOverview';
import { NavigateButton } from 'app/components/NavigateButton';
import { CertificateViewUser } from 'app/components/CertificateViewUser';
import { SettingsView } from 'app/components/SettingsView';
import { DownloadView } from 'app/components/DownloadView';
import { ClassAdmin } from 'app/components/ClassAdmin';
import { ProgressTabs } from 'app/components/ProgressTabs';
import { ResourcesView } from 'app/components/ResourcesView';
import CoachingActivity from 'app/components/CoachingActivity';

import Highcharts from 'highcharts';
import ReactHighcharts from 'highcharts-react-official';
import highchartsMore from 'highcharts/highcharts-more';
import hcXrange from 'highcharts/modules/xrange';

highchartsMore(Highcharts);
(hcXrange)(Highcharts)

import './style.css';
import { StandardInput } from 'app/components/StandardInput';
import { API_CHARTBACK, API_BASE, executeQueryGetAuth, executeQueryPostAuth } from 'app/utils/api';
import { ClassSettingsView } from 'app/components/ClassSettingsView';
import { SingleOverviewClassic } from 'app/components/SingleOverviewClassic';
import { ClassOverviewClassic } from 'app/components/ClassOverviewClassic';
import { ClassSelectDropdown } from 'app/components/ClassSelectDropdown';
import { find, uniq } from 'lodash';
import ReactTable from 'react-table';
import { TextGame } from 'app/components/TextGame';
import { StatementProcessor } from 'app/components/StatementProcessor';
import JsonEditor from 'app/components/JsonEditor';

interface Props extends RouteComponentProps<void> {
	user: UserState;
	actions: AppActions;
}

interface State {
	needsClass: boolean;
	needsPayment: boolean;
	loadingOverview: boolean;
	loadingAllData: boolean;
	allData: any | undefined;
	overviewData: any | undefined;
	blockFromEdit: boolean;
	selectedObjectiveSet: any | undefined;
	userViewPhase: string;
	latestSAData: any;
	loadingSAData: boolean;
	saGameID: string;
	saNPUserID: string;
	saNPPass: string;
	selectedJSONToEdit: string;
	jsonEditData: string;
	hasUnsavedChanges: boolean;
	isSavingConfig: boolean;
	loadingClassData: boolean;
	allClassess: any;
	professorSelectedClass: string;
	selectedClassType: number;
	loadingSubData: boolean;
	loadingUserList: boolean;
	selectedUserClass: string;
	loadedUserData: any;
	saFeature: string;
	loadingConfig: boolean;
	remoteConfig: any;
}

const VLEADER_SESSION_STORAGE_AUTH_TOKEN_IDENTIFIER = 'vleader-session-at-id';
const VLEADER_SESSION_STORAGE_AUTH_TYPE_IDENTIFIER = VLEADER_SESSION_STORAGE_AUTH_TOKEN_IDENTIFIER + '-type';

// Create toaster instance for notifications
const AppToaster = Toaster.create({
	position: Position.TOP_RIGHT,
});

// Configuration options for JSON editor
interface ConfigOption {
	value: string;
	label: string;
	description?: string;
}

const CONFIG_OPTIONS: ConfigOption[] = [
	{ value: 'business', label: 'Business', description: 'Production business configuration' },
	{ value: 'business-dev', label: 'Business Dev', description: 'Development business configuration' },
	{ value: 'educational', label: 'Educational', description: 'Production educational configuration' },
	{ value: 'educational-dev', label: 'Educational Dev', description: 'Development educational configuration' }
];

const ConfigSelect = Select.ofType<ConfigOption>();

@connect(
	(state: RootState, ownProps: any): Partial<Props> => {
		return { user: state.user };
	},
	(dispatch: Dispatch): Pick<Props, 'actions'> => ({
		actions: bindActionCreators(omit(AppActions, 'Type'), dispatch)
	})
)
export class App extends React.Component<Props, State> {
	static defaultProps: Partial<Props> = {

	};

	state = {
		needsClass: false,
		needsPayment: false,
		loadingOverview: false,
		loadingAllData: false,
		allData: undefined,
		overviewData: undefined,
		blockFromEdit: false,
		selectedObjectiveSet: undefined,
		userViewPhase: 'overview',
		latestSAData: undefined,
		loadingSAData: false,
		saGameID: '',
		saNPUserID: '',
		saNPPass: '',
		selectedJSONToEdit: '',
		jsonEditData: '',
		loadingClassData: true,
		allClassess: {},
		professorSelectedClass: '-1',
		loadingSubData: false,
		selectedClassType: -1,
		loadingUserList: true,
		selectedUserClass: '',
		loadedUserData: [],
		saFeature: '',
		loadingConfig: false,
		remoteConfig: undefined,
		hasUnsavedChanges: false,
		isSavingConfig: false
	}

	async loadConfigs(target: any) {
		this.setState({
			loadingConfig: true
		})

		const result = await fetch("https://configs.vleader.net/" + target);

		const json = await result.json();

		this.setState({
			loadingConfig: false,
			remoteConfig: json,
			jsonEditData: JSON.stringify(json, null, 2),
			hasUnsavedChanges: false
		})
	}

	handleJsonChange = (newValue: string) => {
		this.setState({
			jsonEditData: newValue,
			hasUnsavedChanges: true
		});
	}

	validateAndSaveConfig = () => {
		const { selectedJSONToEdit, jsonEditData } = this.state;
		
		try {
			// Validate JSON
			const parsedJson = JSON.parse(jsonEditData);
			
			// If valid, save it
			this.setState({ isSavingConfig: true });
			
			// Use superagent directly to send JSON data properly
			superagent
				.post(API_BASE() + `client/config/${selectedJSONToEdit}`)
				.send(parsedJson)
				.set('Token', this.props.user.authenticationToken)
				.set('Content-Type', 'application/json')
				.end((error: any, response: any) => {
					this.setState({ isSavingConfig: false });
					
					if (error) {
						console.error('Save error:', error);
						AppToaster.show({
							message: `Failed to save configuration: ${error.message || 'Unknown error'}`,
							intent: Intent.DANGER,
							timeout: 5000
						});
					} else {
						this.setState({ 
							hasUnsavedChanges: false,
							remoteConfig: parsedJson
						});
						AppToaster.show({
							message: "Configuration saved successfully!",
							intent: Intent.SUCCESS,
							timeout: 3000
						});
					}
				});
			
		} catch (error) {
			AppToaster.show({
				message: `Invalid JSON: ${error.message}`,
				intent: Intent.DANGER,
				timeout: 5000
			});
		}
	}

	constructor(props: Props, context?: any) {
		super(props, context);
	}

	checkForUnratedCoaching = () => {
		if (!this.props.user || this.props.user.level !== 1) {
			return; // Only check for students (level 1)
		}

		executeQueryGetAuth(`data/coaching/${this.props.user.id}`, {}, this.props.user, (response) => {
			if (response && response.body) {
				const coachingData = response.body;
				console.log('Coaching data received:', coachingData);
				
				// Filter for unrated coaching and also filter out entries without text
				const unratedCoaching = coachingData.filter((item: any) => {
					const isUnrated = !item.support || (item.support !== 'useful' && item.support !== 'not-useful');
					const hasText = item.coachingText || item.text || item.message || item.feedback || item.content;
					
					console.log('Coaching item:', item, 'isUnrated:', isUnrated, 'hasText:', hasText);
					
					return isUnrated && hasText;
				});

				// Remove duplicates based on ID (keep the first occurrence)
				const uniqueUnratedCoaching = unratedCoaching.filter((item: any, index: number, self: any[]) => 
					index === self.findIndex((t: any) => t.id === item.id)
				);

				console.log('Unrated coaching found:', uniqueUnratedCoaching);

				if (uniqueUnratedCoaching.length > 0) {
					this.setState({
						showGlobalCoachingGate: true,
						unratedCoaching: uniqueUnratedCoaching
					});
				}
			}
		});
	}

	startCoachingPolling = () => {
		// Only start polling for students (level 1)
		if (this.props.user && this.props.user.level === 1) {
			// Check immediately
			this.checkForUnratedCoaching();
			
			// Then check every 60 seconds
			const interval = setInterval(() => {
				this.checkForUnratedCoaching();
			}, 60000);

			this.setState({
				coachingPollingInterval: interval
			});
		}
	}

	stopCoachingPolling = () => {
		if (this.state.coachingPollingInterval) {
			clearInterval(this.state.coachingPollingInterval);
			this.setState({
				coachingPollingInterval: null
			});
		}
	}

	handleCoachingRating = (coachingId: string, rating: string) => {
		console.log('Rating coaching:', coachingId, rating);
		
		executeQueryPostAuth(`data/coaching/markread/${coachingId}?support=${rating}`, {}, this.props.user, (response) => {
			console.log('Coaching rating response:', response);
			
			// Update the unrated coaching list
			const updatedUnratedCoaching = this.state.unratedCoaching.filter(item => item.id !== coachingId);
			
			this.setState({
				unratedCoaching: updatedUnratedCoaching
			});

			// If no more unrated coaching, close the gate
			if (updatedUnratedCoaching.length === 0) {
				this.setState({
					showGlobalCoachingGate: false
				});
			}
		});
	}

	closeGlobalCoachingGate = () => {
		this.setState({
			showGlobalCoachingGate: false
		});
	}

	checkForMissingAuthentication = () => {
		// If they hit this page before being signed in
		// forward them to the login page
		if (this.props.user) {
			if (this.props.user.authenticated === false) {
				this.props.history.push("/login");
			}
		}
	}

	handleSelectProfessorClass = (classID: string) => {
		this.setState({
			professorSelectedClass: classID
		});
	}

	getIsClassic = () => {
		return this.state.selectedClassType;
	}

	checkForSelectedClassType = () => {
		if (this.state.selectedClassType === -1) {
			if (this.props.user) {
				this.setState({
					selectedClassType: this.props.user.classicMode
				});
			}
		}
	}

	componentLoadUserData = (classID: string) => {
		this.setState({
			loadingUserList: true,
			selectedUserClass: classID
		});

		executeQueryGetAuth("class/" + classID.toString() + "/students", {}, this.props.user, (response) => {
			let classEnrollmentBase = response.body;

			this.setState({
				loadingUserList: false,
				loadedUserData: classEnrollmentBase
			});
		});
	}

	componentDidMount() {
		this.checkForMissingAuthentication();
		this.checkForSelectedClassType();

		if (this.props.user) {
			if (this.props.user.class === "-1") {
				this.setState({
					needsClass: true
				});
			}

			if (this.props.user.subscription === "0" || this.props.user.subscription === "-1") {
				this.setState({
					needsPayment: true
				});
			}

			if (this.props.user.level === 3) {
				this.componentLoadUserData(this.props.user.class);
				// select the first feature for this user
				this.setState({
					saFeature: 'class'
				});
			}

		}

		executeQueryGetAuth("class", {}, this.props.user, (data) => {
			let incomingData = data.body;

			for (let i = 0; i < incomingData.length; i++) {
				incomingData[i].name = incomingData[i].first + " " + incomingData[i].last + " (" + incomingData[i].email + ")";
			}

			this.setState({
				loadingClassData: false,
				allClassess: incomingData
			});
		});
	}

	handleGoToSimulator = () => {
		window.localStorage.setItem(
			VLEADER_SESSION_STORAGE_AUTH_TYPE_IDENTIFIER,
			'unity'
		);

		window.location.href = "/login?unity=true"
	}

	handleLogout = () => {
		window.localStorage.removeItem(
			VLEADER_SESSION_STORAGE_AUTH_TOKEN_IDENTIFIER
		);

		window.localStorage.removeItem(
			VLEADER_SESSION_STORAGE_AUTH_TOKEN_IDENTIFIER + "--id"
		);

		window.location.reload();
	}

	componentDidUpdate() {
		this.checkForMissingAuthentication();
		this.checkForSelectedClassType();
	}

	renderHeader() {
		return <nav className="main-nav">
			<span className="main-nav-logo"><img src="assets/img/logo.png" /></span>

			<ul id="menu">
				<li onClick={() => {
					this.handleGoToSimulator();
				}}><a><img className="nav-menu-img" src="assets/img/game-controller-svgrepo-com.svg" /></a></li>
				<li onClick={() => {
					this.handleLogout();
				}}><a><img className="nav-menu-img" src="assets/img/logout.svg" /></a></li>
				<li onClick={() => {
					this.props.history.push("/");
					this.setState({
						userViewPhase: 'overview'
					});
				}}><a><img className="nav-menu-img" src="assets/img/home.svg" /></a></li>
			</ul>
		</nav>
	}

	renderProfessorNavigation = () => {
		return <span style={{ display: 'block', marginBottom: '20px' }}>
			<NavigateButton selected={this.state.userViewPhase === 'overview'} onClick={() => {
				this.setState({
					userViewPhase: 'overview'
				});
			}} text="Class Overview" />
			<NavigateButton selected={this.state.userViewPhase === 'performance'} onClick={() => {
				this.setState({
					userViewPhase: 'performance'
				});
			}} text="Class Performance" />
			<NavigateButton selected={this.state.userViewPhase === 'controls'} onClick={() => {
				this.setState({
					userViewPhase: 'controls'
				});
			}} text="Class Settings" />
			<NavigateButton selected={this.state.userViewPhase === 'resources'} onClick={() => {
				this.setState({
					userViewPhase: 'resources'
				});
			}} text="Educator Resources" />
			<NavigateButton selected={this.state.userViewPhase === 'download'} onClick={() => {
				this.setState({
					userViewPhase: 'download'
				});
			}} text="My Downloads" />
			<NavigateButton selected={this.state.userViewPhase === 'settings'} onClick={() => {
				this.setState({
					userViewPhase: 'settings'
				});
			}} text="Settings" />
			<div className={"clearfix"} />
		</span>
	}

	renderUserNavigation = () => {
		return <span style={{ display: 'block', marginBottom: '20px' }}>
			<NavigateButton onClick={() => {
				this.setState({
					userViewPhase: 'overview'
				});
			}} text="Scores" />
			<NavigateButton onClick={() => {
				this.setState({
					userViewPhase: 'certificate'
				});
			}} text="My Certificate" />
			<NavigateButton onClick={() => {
				this.setState({
					userViewPhase: 'download'
				});
			}} text="My Downloads" />
			<NavigateButton onClick={() => {
				this.setState({
					userViewPhase: 'settings'
				});
			}} text="Settings" />
			<div className={"clearfix"} />
		</span>
	}

	renderCurrentUserPhase = () => {
		const {
			userViewPhase
		} = this.state;

		const {
			user
		} = this.props;

		if (userViewPhase === "certificate") {
			return <CertificateViewUser user={user} targetUserID={user.id.toString()} />
		}

		if (userViewPhase === "download") {
			return <DownloadView user={user} />
		}

		if (userViewPhase === "settings") {
			return <SettingsView user={user} />
		}

		if (this.state.selectedClassType === 2) {
			return <SingleOverviewClassic userTutorial={user["tutorial"]} targetUserData={user} user={user} forceNoEdit={false} targetUserID={user.id ? user.id.toString() : ""} />
		}

		return <SingleOverview user={user} forceNoEdit={false} targetUserID={user.id.toString()} />
	}

	getSelectedProfessorClass = () => {
		const {
			professorSelectedClass
		} = this.state;

		const {
			user
		} = this.props;

		if (professorSelectedClass !== '-1') return professorSelectedClass;

		if (user.class.includes(',') === false) return user.class;

		return user.class.split(',')[0];
	}

	renderProfessorPerformanceView = () => {
		const {
			user
		} = this.props;

		const {
			allClassess
		} = this.state;

		const professorSelectedClass = this.getSelectedProfessorClass();

		const classIDForProfessor = user.class;

		if (classIDForProfessor.includes(',')) {
			const allClassesForThisProfessor = uniq(classIDForProfessor.split(','));

			let optionsDefinition: any[] = [];

			for (let i = 0; i < allClassesForThisProfessor.length; i++) {
				const classEntry = allClassesForThisProfessor[i];

				if (classEntry !== "") {
					const matchingClass = find(allClassess, (cls) => {
						//@ts-ignore
						return cls.id.toString() === classEntry
					});

					optionsDefinition.push({
						value: classEntry,
						//@ts-ignore
						label: matchingClass ? matchingClass.class : ''
					});
				}
			}

			return <span>
				<ClassSelectDropdown
					optionsDefinition={optionsDefinition}
					defaultValue={professorSelectedClass}
					onSelect={(value) => {
						this.handleSelectProfessorClass(value);
					}}
				/>
				<Divider />
				<ProgressTabs classID={professorSelectedClass} user={user} />
			</span>
		}
		else {
			return <ProgressTabs classID={user.class} user={user} />
		}
	}

	renderCurrentProfessorPhase = () => {
		const {
			userViewPhase
		} = this.state;

		const {
			user
		} = this.props;

		if (userViewPhase === "performance") {
			return this.renderProfessorPerformanceView();
		}

		if (userViewPhase === "download") {
			return <DownloadView user={user} />
		}

		if (userViewPhase === "settings") {
			return <SettingsView user={user} />
		}

		const {
			loadingClassData,
			allClassess
		} = this.state;

		const professorSelectedClass = this.getSelectedProfessorClass();

		if (userViewPhase === "controls") {

			const allClassesForThisProfessor = uniq(user.class.split(','));

			let optionsDefinition: any[] = [];

			for (let i = 0; i < allClassesForThisProfessor.length; i++) {
				const classEntry = allClassesForThisProfessor[i];

				if (classEntry !== "") {
					const matchingClass = find(allClassess, (cls) => {
						//@ts-ignore
						return cls.id.toString() === classEntry
					});

					optionsDefinition.push({
						value: classEntry,
						//@ts-ignore
						label: matchingClass ? matchingClass.class : ''
					});
				}
			}

			return <span>
				{
					this.state.loadingSubData ? undefined : <ClassSelectDropdown
						optionsDefinition={optionsDefinition}
						defaultValue={professorSelectedClass}
						onSelect={(value) => {
							this.handleSelectProfessorClass(value);
						}}
					/>
				}

				<Divider />
				<ClassSettingsView classID={professorSelectedClass} user={user} />
			</span>
		}

		if (userViewPhase === "resources") {
			return <ResourcesView user={user} />
		}

		if (this.state.selectedClassType === 2) {
			//return <ClassOverviewClassic user={user} />
		}

		if (loadingClassData) {
			return <Spinner />
		}

		// Wait for the user to pop in correctly
		if (user === null || user === undefined) return <span />

		// Render a wrapped class overview setup for the professor
		const classIDForProfessor = user.class;

		if (classIDForProfessor.includes(',')) {
			const allClassesForThisProfessor = uniq(classIDForProfessor.split(','));

			let optionsDefinition: any[] = [];

			for (let i = 0; i < allClassesForThisProfessor.length; i++) {
				const classEntry = allClassesForThisProfessor[i];

				if (classEntry !== "") {
					const matchingClass = find(allClassess, (cls) => {
						//@ts-ignore
						return cls.id.toString() === classEntry
					});

					optionsDefinition.push({
						value: classEntry,
						//@ts-ignore
						label: matchingClass ? matchingClass.class : ''
					});
				}
			}

			return <span>
				{
					this.state.loadingSubData ? undefined : <ClassSelectDropdown
						optionsDefinition={optionsDefinition}
						defaultValue={professorSelectedClass}
						onSelect={(value) => {
							this.handleSelectProfessorClass(value);
						}}
					/>
				}

				<Divider />
				{this.state.selectedClassType === 2 ? <ClassOverviewClassic selectedClass={professorSelectedClass} user={user} /> : <ClassOverview stoppedLoadingData={(

				) => {
					this.setState({
						loadingSubData: false
					});
				}} startLoadingData={() => {
					this.setState({
						loadingSubData: true
					});
				}} selectedClass={professorSelectedClass} user={user} />}
			</span>
		}
		else {
			return (this.state.selectedClassType === 2) ? <ClassOverviewClassic user={user} /> : <ClassOverview stoppedLoadingData={() => {
				this.setState({
					loadingSubData: false
				});
			}} startLoadingData={() => {
				this.setState({
					loadingSubData: true
				});
			}} user={user} />
		}
	}

	renderSAPasswordChanger = () => {
		const {
			saNPUserID,
			saNPPass
		} = this.state;

		return <Callout style={{ marginBottom: '20px' }} intent={Intent.NONE}>
			<span>
				<p>SA Password Changer</p>
				<StandardInput
					autoFocus={true}
					onChange={(value) => { this.setState({ saNPUserID: value.target.value }); }}
					type={"text"}
					value={saNPUserID}
					label={"User ID"} />

				<StandardInput
					autoFocus={true}
					onChange={(value) => { this.setState({ saNPPass: value.target.value }); }}
					type={"text"}
					value={saNPPass}
					label={"New Password"} />

				<Button intent={Intent.PRIMARY} className={Classes.POPOVER_DISMISS} onClick={() => {
					executeQueryPostAuth("users/forceresetpassword?user=" + saNPUserID + "&password=" + saNPPass, { user: saNPUserID, password: saNPPass, }, this.props.user, (response) => {
						AppToaster.show({
							message: "Password updated successfully!",
							intent: Intent.SUCCESS,
							timeout: 3000
						});
					});
				}}>
					Apply
				</Button>
			</span>
		</Callout>
	}

	renderSAChartTester = () => {
		const {
			latestSAData,
			loadingSAData,
			saGameID
		} = this.state;

		let pageInnards: JSX.Element | any = undefined;

		if (latestSAData === undefined) {
			pageInnards = <span>
				<StandardInput
					autoFocus={true}
					onChange={(value) => { this.setState({ saGameID: value.target.value }); }}
					type={"text"}
					value={saGameID}
					label={"Game ID"} />

				<Button intent={Intent.PRIMARY} className={Classes.POPOVER_DISMISS} onClick={() => {
					this.setState({
						loadingSAData: true
					});

					superagent.
						get(API_CHARTBACK() + '?gameID=' + saGameID).
						end((error: any, response: any) => {
							if (error) {
								console.error(error);
							}

							this.setState({
								loadingSAData: false,
								latestSAData: JSON.parse(response.text),
								saGameID: ''
							});
						});
				}}>
					Run
				</Button>
			</span>
		}
		else {
			return <span>
				<ReactHighcharts highcharts={Highcharts} options={latestSAData} />
			</span>
		}

		if (loadingSAData) {
			pageInnards = <Spinner />
		}

		return <Callout style={{ marginBottom: '20px' }} intent={Intent.NONE}>
			{pageInnards}
		</Callout>
	}

	loadStandardObjectivesToEdit = () => {

	}

	renderSAJSONControls = () => {
		return <span>
			{/* <Button text="Edit Standard Objectives" onClick={() => {

			}} /> */}
		</span>
	}

	renderUserViewer = () => {
		const {
			selectedUserClass,
			loadingUserList,
			loadedUserData
		} = this.state;

		if (loadingUserList) {
			return <Card>
				<Spinner />
			</Card>
		}

		const columns = [
			{
				Header: "Email",
				accessor: "email"
			},
			{
				Header: "Student ID",
				accessor: "id"
			},
			{
				Header: "First Name",
				accessor: "first"
			},
			{
				Header: "Certificate",
				accessor: "id",
				Cell: (props) => {
					return <Popover content={<CertificateViewUser user={this.props.user} targetUserID={props.value} />} target={<Button text="View"></Button>} />
				}
			},
		]

		return <Card>
			<h5>Users for classID ({selectedUserClass})</h5>
			<ReactTable style={{ marginTop: '20px' }} columns={columns} data={loadedUserData} pageSize={loadedUserData.length} showPagination={false} showPageSizeOptions={false} />
		</Card>
	}

	renderSAJSONEditor = () => {
		const {
			selectedJSONToEdit,
			jsonEditData,
			hasUnsavedChanges,
			isSavingConfig,
			loadingConfig
		} = this.state;

		if (selectedJSONToEdit === '') {
			return <Card style={{ padding: '20px', maxWidth: '400px' }}>
				<h4>Select Configuration to Edit</h4>
				<p style={{ color: '#5C7080', marginBottom: '15px' }}>
					Choose which configuration you'd like to modify:
				</p>
				<ConfigSelect
					items={CONFIG_OPTIONS}
					itemRenderer={(option: ConfigOption, { handleClick, modifiers }) => (
						<MenuItem
							active={modifiers.active}
							key={option.value}
							onClick={handleClick}
							text={option.label}
							label={option.description}
						/>
					)}
					onItemSelect={(option: ConfigOption) => {
						this.loadConfigs(option.value).then(() => {
							this.setState({
								selectedJSONToEdit: option.value
							});
						});
					}}
					noResults={<MenuItem disabled={true} text="No configurations found." />}
					popoverProps={{ minimal: true }}
				>
					<Button
						text="Select Configuration..."
						rightIcon="caret-down"
						style={{ width: '100%' }}
					/>
				</ConfigSelect>
			</Card>
		}

		if (loadingConfig) {
			return <Spinner />;
		}

		return <span>
			<div style={{ marginBottom: '10px' }}>
				<Button 
					text="Back to Selection" 
					onClick={() => {
						this.setState({
							selectedJSONToEdit: '',
							hasUnsavedChanges: false,
							jsonEditData: ''
						});
					}} 
				/>
				<Button 
					text={isSavingConfig ? "Saving..." : "Save Changes"}
					intent={Intent.PRIMARY}
					disabled={!hasUnsavedChanges || isSavingConfig}
					onClick={this.validateAndSaveConfig}
					style={{ marginLeft: '10px' }}
				/>
				{hasUnsavedChanges && (
					<span style={{ marginLeft: '10px', color: '#d9534f' }}>
						● Unsaved changes
					</span>
				)}
			</div>
			<JsonEditor 
				value={jsonEditData} 
				onChange={this.handleJsonChange}
			/>
		</span>
	}

	renderSystemAdmin = () => {
		const {
			user
		} = this.props;

		const {
			saFeature
		} = this.state;

		let saInnards = <span />

		if (saFeature === 'user') {
			saInnards = this.renderUserViewer();
		}

		if (saFeature === 'json') {
			saInnards = this.renderSAJSONEditor();
		}

		if (saFeature === 'password') {
			saInnards = this.renderSAPasswordChanger();
		}

		if (saFeature === 'gamedebugger') {
			saInnards = <TextGame user={this.props.user} />
		}

		if (saFeature === 'statementprocessor') {
			saInnards = <StatementProcessor user={this.props.user} />
		}

		if (saFeature === 'class') {
			saInnards = <ClassAdmin onClassAction={(action: any, classID: any) => {
				if (action === 'table') {
					this.componentLoadUserData(classID);
				}
			}} user={user} />
		}

		if (saFeature === 'sachart') {
			saInnards = this.renderSAChartTester();
		}

		if (saFeature === 'feedback') {
			saInnards = this.renderFeedbackView();
		}

		return <span>
			<Navbar>
				<NavbarGroup>
					<NavbarHeading>vLeader</NavbarHeading>
					<NavbarDivider />
					<Button onClick={() => { this.setState({ saFeature: 'class' }) }} className={Classes.MINIMAL} text="Class Admin" />
					<Button onClick={() => { this.setState({ saFeature: 'user' }) }} className={Classes.MINIMAL} text="Users" />
					<Button onClick={() => { this.setState({ saFeature: 'json' }) }} className={Classes.MINIMAL} text="JSON" />
					<Button onClick={() => { this.setState({ saFeature: 'sachart' }) }} className={Classes.MINIMAL} text="SA Chart" />
					<Button onClick={() => { this.setState({ saFeature: 'password' }) }} className={Classes.MINIMAL} text="Password Changer" />
					<Button onClick={() => { this.setState({ saFeature: 'gamedebugger' }) }} className={Classes.MINIMAL} text="Game Debugger" />
					<Button onClick={() => { this.setState({ saFeature: 'statementprocessor' }) }} className={Classes.MINIMAL} text="Statement Processor" />
				</NavbarGroup>
			</Navbar>
			<br></br>
			{saInnards}
		</span>
	}

	renderFeedbackView = () => {
		return <CoachingActivity user={this.props.user} />;
	}

	renderGlobalCoachingGate() {
		const { showGlobalCoachingGate, unratedCoaching } = this.state;

		if (!showGlobalCoachingGate || unratedCoaching.length === 0) {
			return null;
		}

		return (
			<Dialog
				isOpen={showGlobalCoachingGate}
				onClose={this.closeGlobalCoachingGate}
				title="You Have New Coaching"
				canEscapeKeyClose={false}
				canOutsideClickClose={false}
				isCloseButtonShown={false}
				style={{ width: '600px' }}
			>
				<div style={{ padding: '20px' }}>
					<H4>New coaching feedback requires your rating</H4>
					<p>Please read the following coaching feedback and let us know how we did before continuing:</p>
					
					{unratedCoaching.map((coaching, index) => {
						console.log('Rendering coaching item:', coaching);
						
						// Try different possible field names for the coaching text
						const coachingText = coaching.coachingText || 
											coaching.text || 
											coaching.message || 
											coaching.feedback || 
											coaching.content ||
											'No text available';
						
						return (
							<Card key={coaching.id || index} style={{ marginBottom: '15px', padding: '15px' }}>
								<H5>Coaching Feedback #{index + 1}</H5>
								<div style={{ 
									marginBottom: '10px', 
									padding: '10px', 
									backgroundColor: '#f5f5f5', 
									borderRadius: '4px',
									whiteSpace: 'pre-wrap',
									wordWrap: 'break-word',
									maxWidth: '100%'
								}}>
									{coachingText}
								</div>
								<div style={{ display: 'flex', gap: '10px' }}>
									<Button 
										intent={Intent.SUCCESS}
										onClick={() => this.handleCoachingRating(coaching.id, 'useful')}
										text="This was Useful"
									/>
									<Button 
										intent={Intent.WARNING}
										onClick={() => this.handleCoachingRating(coaching.id, 'not-useful')}
										text="Thanks, But It's Not Useful"
									/>
								</div>
							</Card>
						);
					})}
					
					<div style={{ marginTop: '20px', textAlign: 'center' }}>
						<Callout intent={Intent.PRIMARY}>
							You must rate all coaching feedback before you can continue using the application.
						</Callout>
					</div>
				</div>
			</Dialog>
		);
	}

	render() {
		const {
			needsClass,
			needsPayment,
			loadingOverview
		} = this.state;

		const {
			user
		} = this.props;

		let mainContent = <span></span>

		if (needsClass) {
			mainContent = <ClassFinder user={this.props.user} onSelected={() => {
				//re-load to reauthenticate the user
				//@ts-ignore
				location.reload(false);
			}} />
		}
		else if (needsPayment) {
			mainContent = <Subscription
				classProduct={user.classProduct}
				user={user}
				onSelected={() => {
					// Reload the page at this point
					this.props.history.push("/");

					this.setState({
						needsPayment: false
					});
				}} />
		}
		else {
			if (loadingOverview) {
				mainContent = <Spinner />
			}
			else {
				if (user.level === 3) {
					mainContent = <span>
						{this.renderSystemAdmin()}
					</span>
				}
				else if (user.level === 2) {
					mainContent = <span>
						{this.renderProfessorNavigation()}
						{this.renderCurrentProfessorPhase()}
					</span>
				}
				else {
					mainContent = <span>
						{this.renderUserNavigation()}
						{this.renderCurrentUserPhase()}
					</span>
				}
			}
		}

		return (
			<div>
				{this.renderHeader()}
				<div className="mainContent">
					{mainContent}
				</div>
				{this.renderGlobalCoachingGate()}
			</div>
		);
	}
}
